export default __webpack_public_path__ + "static/media/web.2bc5affa.svg";